import React from 'react';
import styled, { keyframes } from 'styled-components';
import { OpacityProps, PositionProps } from 'styled-system';

import { Box } from 'components/Box';
import Icon from 'components/Icon/Icon';
import { colors, transition } from 'theme';

const animImagePath = (amount) => keyframes`
  0% {
    stroke-dashoffset: -${amount}px;
  }
  30%, 70% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: ${amount}px;
  }
`;

type Props = PositionProps & OpacityProps & { transform?: string };

const StyledBox = styled(Box)`
  transition: all ${transition} 1s;

  svg {
    path,
    circle {
      stroke: ${colors.silver};
      fill: transparent;
    }

    path,
    polyline {
      stroke-dasharray: 167px;
      stroke-dashoffset: -167px;
      animation: ${animImagePath(167)} 2s infinite;
    }

    circle {
      stroke-dasharray: 30px;
      stroke-dashoffset: -30px;
      animation: ${animImagePath(30)} 2s infinite;
    }
  }
`;

export function ImageSpinner({
  position,
  top,
  left,
  bottom,
  right,
  transform,
  opacity,
  zIndex,
}: Props) {
  return (
    <StyledBox
      position={position}
      top={top}
      left={left}
      bottom={bottom}
      right={right}
      transform={transform}
      opacity={opacity}
      zIndex={zIndex}
    >
      <Icon name="image-path" width={40} />
    </StyledBox>
  );
}
